module.exports = "/assets/packs/images/d590c42323b44f9097c1e426a5f51598.svg";